module.exports = __webpack_public_path__ + "img/RIGID PGG KNUCKLE CRANE TRUCK_RHD.5544e439.jpg";